(() => {
  function initLanoxHomepage(homepage) {
    if (!homepage || homepage.dataset.lanoxInitialized === 'true') return;
    homepage.dataset.lanoxInitialized = 'true';

    const fadeUps = homepage.querySelectorAll('.fade-up');

    if (fadeUps.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
              setTimeout(() => entry.target.classList.add('visible'), index * 100);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      fadeUps.forEach((element) => observer.observe(element));
    }
  }

  const boot = (root = document) => {
    root.querySelectorAll('.lanox-homepage').forEach(initLanoxHomepage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
